import React from 'react';
import styled from '@emotion/styled';
import { Spacer } from 'views/components/atoms/Spacer';
import {
  Invitation,
  ApplicationInvitation,
  GroupInvitation,
} from 'models/Invitation/type';
import { Color, FontSize } from 'views/constants';
import { Typography } from 'views/components/atoms/Typography';
import { localeIds } from 'locals';
import { FormattedMessage } from 'react-intl';
import { Button } from 'views/components/atoms/Button';
import { Driver } from 'views/components/atoms/Driver';
import { Image } from 'views/components/atoms/Image';

const Wrapper = styled.div`
  flex: 1;
  background-color: ${Color.C6};
`;

const HeaderWrapper = styled.div`
  background-color: ${Color.C5};
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  line-height: normal;
  text-align: center;
`;

const ContentsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 36px 0;
`;

const ImageWrapper = styled.div`
  width: 160px;
`;

const ButtonWrapper = styled.div`
  width: 288px;
`;

interface InvitationPageLayoutProps {
  invitation: Invitation;
  onSignUp(): void;
  onLogin(): void;
}

const isApplicationInvitation = (
  arg: ApplicationInvitation | GroupInvitation
): arg is ApplicationInvitation => {
  return 'iconUrl' in arg;
};

export const InvitationPageLayout: React.FC<InvitationPageLayoutProps> = ({
  invitation,
  onSignUp,
  onLogin,
}) => {
  return (
    <Wrapper>
      <HeaderWrapper>
        <Typography size={FontSize.S}>
          <FormattedMessage
            id={localeIds.invitation.invitee}
            values={{ email: invitation.email }}
          />
        </Typography>
        <Typography>
          <FormattedMessage
            id={localeIds.invitation.message}
            values={{
              name: invitation.invitationFor.name,
              inviter: invitation.creatorName,
              br: () => <br />,
            }}
          />
        </Typography>
      </HeaderWrapper>
      <Driver />

      <ContentsWrapper>
        {isApplicationInvitation(invitation.invitationFor) ? (
          <>
            <ImageWrapper>
              <Image src={invitation.invitationFor.iconUrl} />
            </ImageWrapper>
            <Spacer />
          </>
        ) : null}

        <Typography size={FontSize.XXL}>
          {invitation.invitationFor.name}
        </Typography>

        <Spacer size="large" />

        <Typography color={Color.C3}>
          <FormattedMessage id={localeIds.invitation.signUpHelp} />
        </Typography>

        <Spacer />

        <ButtonWrapper>
          <Button type="button" style="primary" onClick={onSignUp}>
            {isApplicationInvitation(invitation.invitationFor) ? (
              <FormattedMessage id={localeIds.invitation.signUpForApp} />
            ) : (
              <FormattedMessage id={localeIds.invitation.signUpForGroup} />
            )}
          </Button>
        </ButtonWrapper>

        <Spacer size="large" />

        <Typography color={Color.C3}>
          <FormattedMessage id={localeIds.invitation.loginHelp} />
        </Typography>

        <Spacer />

        <ButtonWrapper>
          <Button type="button" onClick={onLogin}>
            <FormattedMessage id={localeIds.invitation.login} />
          </Button>
        </ButtonWrapper>
      </ContentsWrapper>
    </Wrapper>
  );
};
